import React, { useEffect } from "react";
import HeaderTop from "_common/component/Layout/Header/HeaderTop";
import { NotificationApi } from "states/api/notification";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

export default function MobileNotice() {
  const { data, refetch } = useQuery(
    ["notice", "list"],
    () =>
      NotificationApi.getList({
        params: {
          page: 1,
          limit: 100,
        },
      }),
    {
      staleTime: 300000,
    }
  );

  useEffect(() => {
    refetch();
  }, []);

  return (
    <div className="container introduce-page !mt-[50px]">
      <HeaderTop title="Thông báo" />
      <div className="no_content mt-[20px]">
        <div className="no_inbox">
          {data?.data?.map((item) => (
            <Link to={`/member/notice/${item?.id}`} key={item?.id}>
              <div className="newsbox">
                <div className="lbox_l">
                  <span className="fcc fe6im fzmmm !text-[14px]">
                    {item?.title}
                  </span>
                </div>
                <div className="lbox_r">
                  <FontAwesomeIcon icon={faChevronRight} color="#707A8A" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
